import { remoteManifestUrl } from '@libs/focus-frontend-build/src/releaseManifest';
import type { ModuleFederationRuntimePlugin } from '@module-federation/runtime';

import { reloadOnce, resolvedRelease } from './releaseResolution';
import reportRemoteLoadFailure, { isRemoteUnreachable } from './reportRemoteLoadFailure';

const releaseResolutionPlugin = (): ModuleFederationRuntimePlugin => ({
  name: 'release-resolution',
  async beforeRequest(args) {
    const release = await resolvedRelease();

    if (!release) {
      return args;
    }

    args.options.remotes.forEach((remote) => {
      const version = release.remotes[remote.name];

      if (version && 'entry' in remote) {
        remote.entry = remoteManifestUrl(remote.name, version);
      }
    });

    return args;
  },
  async errorLoadRemote({ id, remote, error, lifecycle }) {
    const release = await resolvedRelease();
    const name = remote?.name ?? id.split('/')[0];
    const version = release?.remotes[name];

    if (release && version && isRemoteUnreachable(error)) {
      await reportRemoteLoadFailure({
        remote: name,
        version,
        entry: remoteManifestUrl(name, version),
        release: release.release,
        lifecycle,
        error,
      });
      reloadOnce();
    }

    return undefined;
  },
});

export default releaseResolutionPlugin;
